import 'bootstrap/js/dist/modal';

class videoModal {
  constructor() {
    this.videoFullwidth();
  }

  videoFullwidth() {
    // Gets the video src from the data-src on each button
    $(document).on('click', '.js-trigger-videomodelar-full', function (e) {
      e.preventDefault();
      var elem = $(e.currentTarget);
      var videoID = elem.attr('data-videoURL');
      var videoType = elem.attr('data-videoType');
      let videoSrc = '';
      if ('vimeo' == videoType) {
        videoSrc = videoID;
      } else {
        videoSrc =
          'https://www.youtube.com/embed/' +
          videoID +
          '?mute=0&autoplay=1&rel=0&showinfo=1&controls=1&autopause=0';
      }

      $('#videoModalFull iframe#video').attr('src', videoSrc);
    });

    // stop playing the youtube video when I close the modal
    $('#videoModalFull').on('hide.bs.modal', function (e) {
      // a poor man's stop video
      $('#video').attr('src', '');
    });
  }
}

export default videoModal;
new videoModal();
